import Constant from '@/lib/constant';
export default {
  permission: {
    inserted(el, binding, vnode) {
      const {
        value,
        modifiers: { not }
      } = binding;
      const {
        context: {
          $store: { getters }
        }
      } = vnode;
      const handler = () => {
        const roles = value.split(',').map(role => Constant.RoleList[role]);
        const isCheck = getters.getRoles.some(role => roles.some(role1 => role1 === role));
        !isCheck && !not && el.parentNode.removeChild(el);
        isCheck && not && el.parentNode.removeChild(el);
      };
      handler();
    }
  }
};
